var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseTrackOnAlbum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 39,
    viewBox: "0 0 53 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5917 4.20302C4.65536 6.52248 0.450195 12.2981 0.450195 19.0559C0.450196 25.8137 4.65536 31.5893 10.5917 33.9087V30.7406C6.29855 28.606 3.34838 24.1752 3.34838 19.0553C3.34838 13.9354 6.29855 9.50454 10.5917 7.36994V4.20302Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5917 10.731C7.96481 12.5642 6.24624 15.6091 6.24624 19.0554H9.14452C9.14452 17.4251 9.68295 15.9205 10.5917 14.7099V10.731Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2941 34.4562V38.2847H18.2375C16.1231 38.2847 14.4091 36.5707 14.4091 34.4562V3.82847C14.4091 1.71407 16.1231 0 18.2375 0H48.8653C50.9797 0 52.6938 1.71407 52.6938 3.82847V22.9708H48.8653V3.82847H18.2375V34.4562H39.2941Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5514 9.82287V19.4112C32.9474 19.2361 32.3017 19.1424 31.6372 19.1424C28.5657 19.1424 25.8945 21.1457 25.8945 23.928C25.8945 26.7102 28.5657 28.7135 31.6372 28.7135C34.7087 28.7135 37.3799 26.7102 37.3799 23.928V16.9764L40.1466 18.8209L42.2702 15.6354L33.5514 9.82287ZM33.5514 23.928C33.5514 24.3174 32.7945 24.8851 31.6372 24.8851C30.4799 24.8851 29.723 24.3174 29.723 23.928C29.723 23.5385 30.4799 22.9708 31.6372 22.9708C32.7945 22.9708 33.5514 23.5385 33.5514 23.928Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8092 3.8289V0.0004327L48.8653 0C50.9797 0 52.6938 1.71407 52.6938 3.82847L52.6942 34.4567C52.6942 36.5711 50.9802 38.2852 48.8658 38.2852L18.2375 38.2847C16.1231 38.2847 14.4091 36.5707 14.4091 34.4562L14.4095 15.3143L18.238 15.3143L18.2375 34.4562L48.8658 34.4567L48.8653 3.82847L27.8092 3.8289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseTrackOnAlbum);
export default __webpack_public_path__ + "static/media/release-track-on-album.79109325.svg";
export { ForwardRef as ReactComponent };